module.exports = __webpack_public_path__ + "img/grey_as.f9a8281d.svg";